import { Component, ElementRef, Input, OnDestroy, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import * as _ from 'lodash';
import { ChannelData } from 'src/app/core/models';
import { ChannelService } from 'src/app/home/channel/channel.service';
import { VoucherCardType } from 'src/app/core/enums/CardType';
import { VoucherCatgWithVoucherList } from 'src/app/core/models/VoucherCatgWithVoucherList';
import { RewardService } from 'src/app/account/services/reward.service';
import { ToastService } from 'src/app/shared/services/toast.service';
import { OrderVoucher } from 'src/app/core/models/OrderVoucher';
import { OrderData } from 'src/app/core/models/OrderData';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { VoucherTypeExtraResponse } from 'src/app/core/models/VoucherTypeExtraResponse';
import { debounceTime } from 'rxjs/operators';

@Component({
  selector: 'app-select-voucher',
  templateUrl: './select-voucher.component.html',
  styleUrls: ['./select-voucher.component.scss'],
})
export class SelectVoucherComponent implements OnInit, OnDestroy {
  @Input() storeId: number;
  @Input() applicableVouchers: VoucherCatgWithVoucherList[];
  @Input() selectedVouchers: OrderVoucher[];
  @Input() orderData?: OrderData;
  @Input() showEnterVoucherCode: boolean = true;

  @ViewChildren("content") contentListEl: QueryList<ElementRef>;
  @ViewChild("content") contentEl: ElementRef;
  @ViewChild('searchBar') searchBarEl: ElementRef;

  channelData: ChannelData;
  applicableVouchersFilter: VoucherCatgWithVoucherList[];
  cardTypes: any = VoucherCardType;
  isLoggedIn: boolean = false;
  isOnLoad: boolean = false;
  channelId: number;

  searchCode: string = "";
  searchedCode: string = "";
  searchVouchers: VoucherTypeExtraResponse[] = [];
  searchFgroup: UntypedFormGroup;

  constructor(
    private rewardService: RewardService,
    private channelService: ChannelService,
    private toastService: ToastService,
    private fb: UntypedFormBuilder,
  ) {
    this.searchFgroup = this.fb.group({
      searchCode: ['']
    });
  }

  async ngOnInit() {
    await this.channelService.getChannelDataCheck();
    this.channelData = this.channelService.getChannelData();
    this.channelId = this.channelData.channelId;
    this.applicableVouchersFilter = _.cloneDeep(this.applicableVouchers);

    this.searchFgroup.get('searchCode').valueChanges
      .pipe(
        debounceTime(1000)
      )
      .subscribe(value => {
        this.onSearch();
      });
  }

  onApply() {
    this.rewardService.applyVoucher.next({ selectedVoucher: this.selectedVouchers, storeId: this.storeId });
  }

  onBack() {
    this.rewardService.selectDialog.next({ isShow: false });
  }

  get searchFg() { return this.searchFgroup }

  get searchF() { return this.searchFgroup.controls; }

  get showNoVouchers(): boolean {
    if (this.searchCode) {
      return !this.searchVouchers?.length;
    }

    return !this.applicableVouchers?.some(group => group.voucherList?.length);
  }

  async onSearch() {
    this.searchCode = this.searchFgroup.value.searchCode ?? "";

    if (this.searchCode) {
      this.searchVouchers = <VoucherTypeExtraResponse[]>await this.rewardService.getStoreVoucherType(this.storeId, this.channelId, this.searchCode);
    } else {
      this.searchVouchers = [];
    }
  }

  resetSearch() {
    this.searchFgroup.get('searchCode')?.reset();
    this.searchCode = "";
    this.searchVouchers = [];
  }

  ngOnDestroy(): void {
    this.toastService.closeToast();
  }
}
